export type LaboratoryResultTab = 'detail' | 'parameter-hasil-uji';

export function parseLaboratoryResultHash(hash: string): LaboratoryResultTab {
  const raw = (hash || '').replace(/^#/, '').trim().toLowerCase();
  if (
    raw === 'parameter-hasil-uji' ||
    raw === 'parameter_hasil_uji' ||
    raw === 'hasil-uji' ||
    raw === 'parameters'
  ) {
    return 'parameter-hasil-uji';
  }
  return 'detail';
}

export function buildLaboratoryResultHash(tab: LaboratoryResultTab): string {
  return tab === 'parameter-hasil-uji' ? '#parameter-hasil-uji' : '#detail';
}
